import React, { lazy, Suspense } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';

export const AppViews = () => {

  const history = useHistory()
  let currentPath = history.location?.pathname;
  const availablePaths = [
    //    '/',
    '/overview',
    '/notifications',
    '/notifications/add',
    '/locations',
    '/displays',
    '/calendar',
    '/dispatch',
    '/routes',
    '/routes/add',
    '/map',
    '/inbox',
    '/contacts',
    '/contacts/add',
    '/users',
    '/users/add',
    '/groups',
    '/clients',
    '/clients/add',
    '/requests',
    '/requests/add',
    '/quotes',
    '/quotes/add',
    '/jobs',
    '/jobs/add',
    '/invoices',
    '/invoices/add',
    '/reports',
    '/reports/check-in',
    '/reports/headcount',
    '/content-manager',
    '/files',
    '/files/add',
    '/documents',
    '/documents/add',
    '/forms',
    '/forms/add',
    '/maps',
    '/web-links',
    '/web-links/add', 
    '/verify',
  ]

  const isRouteAvailable = availablePaths.includes(currentPath);
  return (
    <Suspense fallback={<Loading cover="content" fallback={true} />}>
      <>
        <Route path={'/overview'} component={lazy(() => import('./overview'))} />
        <Route path={'/notifications/:notification_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./notifications/detail'))} />
        <Route path={'/notifications'} exact component={lazy(() => import('./notifications/list'))} />
        <Route path={'/notifications/add'} exact component={lazy(() => import('./notifications/add'))} />
        <Route path={'/locations'} component={lazy(() => import('./locations/list'))} />
        <Route path={'/displays'} component={lazy(() => import('./displays'))} />
        <Route path={'/calendar'} component={lazy(() => import('./calendar'))} />
        <Route path={'/dispatch'} component={lazy(() => import('./dispatch'))} />
        <Route path={'/map'} component={lazy(() => import('./map'))} />
        <Route path={'/routes'} exact component={lazy(() => import('./routes/detail'))} />
        <Route path={'/routes/add'} exact component={lazy(() => import('./routes/add'))} />
        <Route path={'/inbox'} component={lazy(() => import('./inbox'))} />
        <Route path={'/contacts/:contact_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./contacts/detail'))} />
        <Route path={'/contacts'} exact component={lazy(() => import('./contacts/list'))} />
        <Route path={'/contacts/add'} exact component={lazy(() => import('./contacts/add'))} />
        <Route path={'/users/:user_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./users/detail'))} />
        <Route path={'/users'} exact component={lazy(() => import('./users/list'))} />
        <Route path={'/users/add'} exact component={lazy(() => import('./users/add'))} />
        <Route path={'/groups/:group_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./groups/detail'))} />
        <Route path={'/groups'} exact component={lazy(() => import('./groups/list'))} />
        <Route path={'/clients/:client_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./clients/detail'))} />
        <Route path={'/clients'} exact component={lazy(() => import('./clients/list'))} />
        <Route path={'/clients/add'} exact component={lazy(() => import('./clients/add'))} />
        <Route path={'/requests/:request_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./requests/detail'))} />
        <Route path={'/requests'} exact component={lazy(() => import('./requests/list'))} />
        <Route path={'/requests/add'} exact component={lazy(() => import('./requests/add'))} />
        <Route path={'/quotes/:quote_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./quotes/detail'))} />
        <Route path={'/quotes'} exact component={lazy(() => import('./quotes/list'))} />
        <Route path={'/quotes/add'} exact component={lazy(() => import('./quotes/add'))} />
        <Route path={'/jobs/:job_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./jobs/detail'))} />
        <Route path={'/jobs'} exact component={lazy(() => import('./jobs/list'))} />
        <Route path={'/jobs/add'} exact component={lazy(() => import('./jobs/add'))} />
        <Route path={'/invoices'} exact component={lazy(() => import('./invoices/list'))} />
        <Route path={'/invoices/add'} exact component={lazy(() => import('./invoices/add'))} />
        <Route path={'/reports/check-in'} exact component={lazy(() => import('./reports/check-in'))} />
        <Route path={'/reports/headcount'} exact component={lazy(() => import('./reports/headcount'))} />
        <Route path={'/reports'} exact component={lazy(() => import('./reports/list'))} />
        <Route path={'/files/:file_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./files/detail'))} />
        <Route path={'/files'} exact component={lazy(() => import('./files/list'))} />
        <Route path={'/files/add'} exact component={lazy(() => import('./files/add'))} />
        <Route path={'/documents/:document_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./documents/detail'))} />
        <Route path={'/documents'} exact component={lazy(() => import('./documents/list'))} />
        <Route path={'/documents/add'} exact component={lazy(() => import('./documents/add'))} />
        <Route path={'/forms/:form_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./forms/detail'))} />
        <Route path={'/forms/:form_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/edit'} exact component={lazy(() => import('./forms/edit'))} />
        <Route path={'/forms'} exact component={lazy(() => import('./forms/list'))} />
        <Route path={'/forms/add'} exact component={lazy(() => import('./forms/add'))} />
        <Route path={'/maps/:map_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./maps/detail'))} />
        <Route path={'/maps'} exact component={lazy(() => import('./maps/list'))} />
        <Route path={'/web-links/:weblink_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./web-links/detail'))} />
        <Route path={'/web-links'} exact component={lazy(() => import('./web-links/list'))} />
        <Route path={'/web-links/add'} exact component={lazy(() => import('./web-links/add'))} /> 
        <Route path={'/verify'} exact component={lazy(() => import('./verify'))} />
        {!isRouteAvailable ? <Redirect from={''} to={'/overview'} /> : null}
      </>
    </Suspense>
  )
}

export default React.memo(AppViews);